import { styled, Box } from '@mui/material';

const Container = styled(Box)(() => ({
  height: 'calc(100vh - 100px)',
  overflow: 'auto'
}));

export {
  Container
}